import { Component } from 'react'
import { connect } from 'react-redux'
import * as ACT from 'components/Contacts/actions'
import { ContactDetail } from './ContactDetail'

@connect(({ contacts }) => {
  const { currentBusinessCard } = contacts

  return {
    currentBusinessCard
  }
})
class ContactDetailContainer extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id && typeof this.props.id !== 'object') {
      this.props.dispatch({
        type: ACT.CONTACT_DETAIL_FETCH_REQUESTED,
        payload: {
          id: this.props.id
        }
      })
    }
  }

  render() {
    const { currentBusinessCard, toggleModal, isVisible } = this.props
    return (
      currentBusinessCard && (
        <ContactDetail user={currentBusinessCard} toggleModal={toggleModal} isVisible={isVisible} />
      )
    )
  }
}

export default ContactDetailContainer
